import { ErrorInfo, PropsWithChildren } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import useUser from '../../../../hooks/use-user'
import handleAPIError from '../../handler'
import FallbackComponent from '../fallback-component'

export default function WellsErrorBoundary({ children }: PropsWithChildren<{}>) {
  const { user } = useUser()
  return (
    <ErrorBoundary
      FallbackComponent={FallbackComponent}
      onReset={() => window.location.reload()}
      onError={(error: Error, info: ErrorInfo) => handleAPIError(error, info, user)}
    >
      {children}
    </ErrorBoundary>
  )
}
